import React from 'react'
import { object, string, arrayOf, number } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { getImageOrDefaultSrc, urlWithTrack, getNameAbbr } from '../../helpers/common'
import { sendClickEventToInsights } from '../../utils/insights'
import { EMPTY_ARRAY, PROFESSIONAL_PLACEHOLDER_IMAGE, PROFESSIONALS } from '../../utils/constants'
import AdLink from '../ui/ad-link/AdLink'
import SpecItem from '../ui/specs/SpecItem'
import SpecListItem from '../ui/specs/SpecListItem'
import Insights from './Insights'
import { professionalsMessages as messages } from './messages'

const imagesIndex = [0, 1, 2]

const Professional = ({
  images = EMPTY_ARRAY,
  scope,
  logo,
  name,
  speciality,
  countries = EMPTY_ARRAY,
  expertise = EMPTY_ARRAY,
  categories = EMPTY_ARRAY,
  offices = EMPTY_ARRAY,
  count,
  url,
  insights
}) => {
  let renderProjectsCount = null
  const handleLinkClick = () => {
    sendClickEventToInsights(insights.category, insights.label, insights.value, insights.version)
  }
  const trackedUrl = urlWithTrack(url, PROFESSIONALS)

  const renderImages = imagesIndex.map(index => (
    <div key={name + 'image' + index} className='list-view__single-image-wrapper'>
      <div
        style={{ backgroundImage: `url("${getImageOrDefaultSrc(images[index], PROFESSIONAL_PLACEHOLDER_IMAGE)}")` }}
        className='list-view__background-image'
        data-object-fit='cover'
      />
    </div>
  ))
  if (count) {
    const projectsMessage = count === 1 ? { ...messages.project } : { ...messages.projects }
    renderProjectsCount = (
      <span>
        {count}
        {' '}
        <FormattedMessage {...projectsMessage} />
      </span>
    )
  }

  return (
    <Insights {...insights}>
      <div className='list-view'>
        {/* Grid Images */}
        <div className='list-view__image-container'>
          <AdLink href={trackedUrl} onClick={handleLinkClick}>
            {renderImages}
          </AdLink>
        </div>

        <div className='list-view__content'>
          {/* Item Description */}
          <div className='list-view__description'>
            {
              logo
                ? <img className='list-view__logo' src={logo} alt='Professional Logo' />
                : <div className='list-view__logo list-view__logo--placeholder'>{getNameAbbr(name)}</div>
            }
            <div className='list-view__data'>
              <h2 className='list-view__name'>
                <AdLink className='list-view__professional-link' href={trackedUrl}>{name}</AdLink>
              </h2>
              <p className='list-view__speciality'>
                <AdLink className='list-view__professional-link' href={trackedUrl}>{speciality}</AdLink>
              </p>
              <p className='list-view__projects-info'>
                <SpecListItem scope={scope} item='country' items={countries} isStringItem landingUrl={trackedUrl} />
                {!!count && !!countries.length && <span> | </span>}
                {renderProjectsCount}
              </p>
            </div>
          </div>

          {/* Expertise spec */}
          <SpecItem scope={scope} item='expertise' data={expertise} landingUrl={trackedUrl} />

          {/* Projects Categories spec */}
          <SpecItem scope={scope} item='categories' data={categories} landingUrl={trackedUrl} />

          {/* Offices Worked With spec */}
          <SpecItem scope={scope} item='offices' data={offices} landingUrl={trackedUrl} />
        </div>
      </div>
    </Insights>
  )
}

Professional.propTypes = {
  images: arrayOf(string),
  scope: string,
  logo: string,
  name: string,
  speciality: string,
  countries: arrayOf(object),
  expertise: arrayOf(object),
  categories: arrayOf(object),
  offices: arrayOf(object),
  count: number,
  url: string,
  insights: object
}

export default React.memo(Professional)
